import { fetchOrderScans } from 'fetch/orderFetch';
import { PlannerOrder } from 'pages/planner/utils/usePlannerData';
import { useEffect, useRef } from 'react';
import { Order, ScanType } from 'types/orderTypes';

const hubScanType = [
  ScanType.Hub,
  ScanType.HubSort,
  ScanType.Pickup,
  ScanType.Delivery,
  ScanType.Warehouse,
  ScanType.Presort,
  ScanType.Info,
  ScanType.Machine,
];

export const OrderFilterWithHubScan = async (order: Order | PlannerOrder) => {
  const scans = await fetchOrderScans(order.id);

  const filter = (acc, currentScan) => {
    if (hubScanType.includes(currentScan.scanType)) {
      acc.push(currentScan);
    }
    return acc;
  };

  const filterResult = scans.reduce(filter, []);

  const orderHasHubScan = filterResult.length > 0;

  return orderHasHubScan;
};

export const useOrderWithHubScan = (orders?: Order[] | PlannerOrder[]) => {
  const scans = useRef([]);

  useEffect(() => {
    orders?.forEach(async order => {
      /* Avoid the multiple call on `Fetch Scans` API */
      if (scans.current[order.id]) {
        scans.current[order.id] = await OrderFilterWithHubScan(order);
      }
    });
  }, [orders]);

  return scans.current;
};
